import { useEffect } from 'react';
import { useLocation } from 'wouter';

/**
 * ScrollToTop component - Scrolls to top on route changes.
 * Should be placed inside the Router/Layout component.
 */
export default function ScrollToTop() {
  const [location] = useLocation();

  useEffect(() => {
    // Scroll to top when location changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use 'instant' to avoid animation conflicts with page transitions
    });
  }, [location]);

  return null;
}
